import styled from 'styled-components';

const FaqItemStyle = styled.div`
	--distanceCategoriesTitle: var(--sp4x);
	--distanceTitlesWrapper: var(--sp3x);
	--borderRadius: var(--sp1-5x);
	--paddingAnswerWrapperTB: var(--sp3x);
	--paddingAnswerWrapperLR: var(--sp3x);
	--sizeArrow: var(--sp3x);
	--padAnswer: var(--sp2x);

	.wrapper-categories-title {
		display: flex;
		flex-direction: column;
		gap: var(--distanceCategoriesTitle);
	}

	.wrapper-all-title-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--distanceTitlesWrapper);

		.title-answer-wrapper {
			.wrapper-ask {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: var(--paddingAnswerWrapperTB) var(--paddingAnswerWrapperLR);

				margin: calc(-1 * var(--paddingAnswerWrapperTB)) calc(-1 * var(--paddingAnswerWrapperLR));
			}

			.collapse-icon {
				font-size: var(--sizeArrow);
				transition: all var(--trTime) ease-out;
				opacity: 0;
				transform: rotate(-90deg);
				width: var(--sizeArrow) !important;
				height: var(--sizeArrow) !important ;
			}

			.answer-wrapper {
				overflow: hidden;

				.answer-text {
					padding-top: var(--padAnswer);
				}
			}
		}
	}

	#collapse-item {
		border: 2px solid var(--neutral600);
		border-radius: var(--borderRadius);
		padding: var(--paddingAnswerWrapperTB) var(--paddingAnswerWrapperLR);
		transition: border var(--trTime) ease-out;

		&.active {
			.collapse-icon {
				transform: rotate(90deg) !important;
			}
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					border-color: var(--mainColor);

					.collapse-icon {
						opacity: 1;
					}
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceCategoriesTitle: var(--sp3x);
		--paddingAnswerWrapperTB: var(--sp2x);
		--paddingAnswerWrapperLR: var(--sp2-5x);
		--distanceTitlesWrapper: var(--sp2x);
		--borderRadius: var(--sp1-5x);
		--padAnswer: var(--sp2x);

		#collapse-item {
			border: 1px solid var(--neutral600);
		}
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceCategoriesTitle: var(--sp3x);
		--paddingAnswerWrapperTB: var(--sp2x);
		--paddingAnswerWrapperLR: var(--sp2x);
		--distanceTitlesWrapper: var(--sp2x);
		--borderRadius: var(--sp1-5x);
		--padAnswer: var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceCategoriesTitle: var(--sp2x);
		--paddingAnswerWrapperTB: var(--sp2x);
		--paddingAnswerWrapperLR: var(--sp2x);
		--distanceTitlesWrapper: var(--sp2x);
		--borderRadius: var(--sp1-5x);
		--padAnswer: var(--sp2x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceCategoriesTitle: var(--sp3x);
		--paddingAnswerWrapperTB: var(--sp2x);
		--paddingAnswerWrapperLR: var(--sp2x);
		--distanceTitlesWrapper: var(--sp2x);
		--borderRadius: var(--sp1-5x);
		--padAnswer: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceCategoriesTitle: var(--sp2x);
		--paddingAnswerWrapperTB: var(--sp1-5x);
		--paddingAnswerWrapperLR: var(--sp1-5x);
		--distanceTitlesWrapper: var(--sp1x);
		--borderRadius: var(--sp1-5x);
		--padAnswer: var(--sp1x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceCategoriesTitle: var(--sp2x);
		--paddingAnswerWrapperTB: var(--sp1-5x);
		--paddingAnswerWrapperLR: var(--sp1-5x);
		--distanceTitlesWrapper: var(--sp1x);
		--borderRadius: var(--sp1x);
		--padAnswer: var(--sp1x);
	}
`;
export default FaqItemStyle;
